import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

import { FormaPago } from '../../../models/forma-pago';
import { FormaPagoService } from '../../../services/forma-pago.service';
import { SessionService } from '../../../services/session.service';
import { Validation } from '../../../config/validation';
import { SweetMessage } from '../../../config/sweet-message';

@Component({
  selector: 'app-forma-pago-add',
  templateUrl: './forma-pago-add.component.html',
  styleUrls: ['./forma-pago-add.component.css'],
  providers: [FormaPagoService,SessionService]
})

export class FormaPagoAddComponent implements OnInit {

  public title: String;
	public formaPago: FormaPago;
	public msg: SweetMessage;
	myForm: FormGroup;
	public vl: Validation;
	public loading = false;
  
  constructor(
    private FormaPagoService: FormaPagoService,
		public fb: FormBuilder,
		private ss: SessionService,
  ) { 
    this.title = "Crear Forma Pago";
  }

  ngOnInit() {
    //Inicializar Formulario
		this.onForm();
		//Inicializacion de Objectos
		this.msg = new SweetMessage();
		//Inicializacion de Objecto de validacion
		this.vl = new Validation();
		//Inicializacion de objecto Banco
		this.formaPago = new FormaPago();
  }

  onSubmit() {
		//setea valores del formulario a la entidad
		this.setValueEntity();
		this.loading = true;
		this.FormaPagoService.save(this.formaPago).subscribe(
			res => {
				this.loading = false;
				this.msg.showMessage('success-message', res.message);
				this.formaPago = new FormaPago();
				this.onForm();
			},
			err => {
				this.loading = false;
				this.msg.showMessage('error-message',err);
			}
		);
  }
  
  onForm() {
		this.myForm = this.fb.group({
			nombre: ['', [Validators.required, Validators.pattern(/[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]*/)]],
		});
  }
  
  setValueForm() {
		this.myForm.setValue({
			nombre: this.formaPago.nombre
		});
	}

  setValueEntity(){
		this.formaPago.nombre = this.myForm.controls['nombre'].value;
		this.formaPago.empresa_id = this.ss.getData('empresa_id');
		this.formaPago.usuario_id = this.ss.getData('usuario_id');
	}

	validErrorForm(campo){
		return this.vl.validErrorForm(campo,this.myForm);
	}

	validTypeMsgForm(nombre,campo){
		return this.vl.validTypeMsgForm(nombre,campo,this.myForm);
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/cobros/forma-pago-add/forma-pago-add.component.ts